import { Track } from "@hooks/useSpotifyTracks";

export class SongUtil {
  public static sameSong(track: Track, currentTrackName: string, artistName: string): boolean {
    return (
      track.name.toLowerCase() === currentTrackName.toLowerCase() &&
      track.artists.includes(artistName)
    );
  }
}
